// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__WxPPo","bigColWidth":"Table_bigColWidth__jxTZu","biggerColWidth":"Table_biggerColWidth__PDwUc","row":"Table_row__3jkir","col":"Table_col__YgtpZ"};